import store from '../redux/store'
import { ACCOUNT_SET_HACK_CHINESE, ACCOUNT_SET_SKRITTER, SET_AUTHENTICATED, SET_STORY_DIFFICULTY } from '../redux/types'
import { clearLocal, getIntegrationsTokenForUser, updateNewTokenToDB } from '../redux/actions/userAction'
import { refreshSkritterAuthToken } from '../services/skritter'
import { getProfile } from '../redux/actions/myAccountAction'
import { profileLanguageFields } from '../i18n/languages'

export const checkOtpAuth = async (): Promise<boolean> => {
  try {
    const userData = localStorage.getItem('user')

    if (!userData) {
      return false
    }
    let user
    try {
      user = JSON.parse(userData)
    } catch (error) {
      clearLocal()
      return false
    }

    if (!user?.credentials?.memberId) {
      console.warn('[Auth] No memberId in user data, clearing localStorage.')
      clearLocal()
      return false
    }

    let token = user.authToken
    if (!token) {
      token = localStorage.getItem('authToken')
    }

    try {
      // First, get fresh profile data from API
      const profileData = await getProfile()

      if (profileData) {
        // Update the user object with fresh profile data
        const updatedUserObject = {
          ...user,
          credentials: {
            memberId: profileData?.id,
            email: profileData?.email,
            createdAt: profileData?.createdAt || null,
            metaData: {
              firstName: profileData?.customFields?.firstName || '',
            },
            customFields: {
              level: profileData?.customFields?.level || 'beginner',
              ...(profileData?.customFields || {}),
              ...profileLanguageFields(profileData?.customFields),
            },
          },
          membership: {
            id: profileData?.id,
            name: profileData?.membership?.name,
            amount: 0,
            oneTime: false,
            plan: profileData?.membership?.name,
          },
          stripe: profileData?.stripe,
          paymentProfile: profileData?.paymentProfile,
          subscriptionStatus: profileData?.subscriptionStatus || null,
          // Carry the server-derived audience flags through. getProfile() has already dispatched
          // them via SET_PROFILE, but the SET_AUTHENTICATED below resets both to null when the
          // payload omits them — so leaving them out here wipes, on every page load, the state
          // that decides whether the trial and the Back-to-School campaign render at all.
          trialEligibility: profileData?.trialEligibility || null,
          backToSchool2026: profileData?.backToSchool2026 || null,
          authToken: token,
        }

        // Update localStorage with fresh data
        localStorage.setItem('user', JSON.stringify(updatedUserObject))
        localStorage.setItem('authToken', token)

        // Dispatch SET_AUTHENTICATED with fresh data
        store.dispatch({
          type: SET_AUTHENTICATED,
          payload: updatedUserObject,
        })
        store.dispatch({ type: SET_STORY_DIFFICULTY, payload: profileData?.customFields?.difficulty_level })
      } else {
        // Fallback to existing user data if profile fetch fails
        store.dispatch({
          type: SET_AUTHENTICATED,
          payload: { ...user },
        })
      }
      getIntegrationsToken()
      return true
    } catch (error) {
      clearLocal()
      return false
    }
  } catch (error) {
    clearLocal()
    return false
  }
}

export const getIntegrationsToken = async () => {
  getIntegrationsTokenForUser().then(async (data: any) => {
    store.dispatch({ type: ACCOUNT_SET_HACK_CHINESE, payload: { token: data.hack_chinese_token } })
    let skritter = data.skritter
    let skritter_token = data?.skritter_token

    if (data?.skritter_token) {
      // expires_in was in seconds
      // if current time less than or equal to Skritter access_token's expiration time (minus 1 Hours)
      // refetch new access_token
      const expires_in = skritter.expires_in ? parseInt(skritter.expires_in) : 0
      const cTimeSeconds = Math.floor(Date.now() / 1000)

      if (cTimeSeconds >= expires_in - 3600) {
        try {
          const res: any = await refreshSkritterAuthToken(skritter.refresh_token)
          if (res.access_token) {
            skritter_token = res.access_token
            skritter.refresh_token = res.refresh_token
            skritter.expires_in = (parseInt(res.expires_in) + cTimeSeconds).toString()
            skritter.skritter_token = skritter_token

            const updatePayload = {
              skritter_token: skritter_token,
              refresh_token: skritter.refresh_token,
              expires_in: skritter.expires_in.toString(),
              user_id: skritter.user_id,
              token_type: skritter.token_type,
            }
            await updateNewTokenToDB(updatePayload)

            store.dispatch({
              type: ACCOUNT_SET_SKRITTER,
              payload: { token: skritter_token, skritter: skritter },
            })
            localStorage.setItem('skritterData', JSON.stringify({ ...skritter }))
          }
        } catch (error) {}
      }
    }
    if (!skritter) {
      skritter = {}
    }
    store.dispatch({
      type: ACCOUNT_SET_SKRITTER,
      payload: {
        token: skritter_token || '',
        skritter: skritter,
      },
    })
    localStorage.setItem('skritterData', JSON.stringify({ ...skritter }))
  })
}
